import { render, staticRenderFns } from "./EditProfileSecu.vue?vue&type=template&id=2a6686a4"
import script from "./EditProfileSecu.vue?vue&type=script&lang=js"
export * from "./EditProfileSecu.vue?vue&type=script&lang=js"
import style0 from "./EditProfileSecu.vue?vue&type=style&index=0&id=2a6686a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports